import { Observable } from 'rxjs';
import { Feature, IsNumberValueProperty } from '../../../projects/client';
import { FormControl } from '@angular/forms';

export interface FetchFeaturesForInstallationGatewaysOutcome {
  [key: string]: Observable<Feature<unknown, unknown>[]>;
}

export interface FetchFeaturesForInstallationGatewaysOutcomeResolved {
  [key: string]: Feature<unknown, unknown>[] | null;
}

export enum RoomsErrors {
  ROOM_NOT_UNIQUE = 'Name should be unique.',
}

export const roomsErrorsTranslations = {
  [RoomsErrors.ROOM_NOT_UNIQUE]: '+COMMISSIONING.ROOM.EDIT_ROOM_MODAL.ROOM_NOT_UNIQUE',
};

export enum RoomTypes {
  BATHROOM = 'bathroom',
  BEDROOM = 'bedroom',
  HALLWAY = 'hallway',
  LIVINGROOM = 'livingroom',
  KITCHEN = 'kitchen',
  OFFICE = 'office',
  TOILET = 'toilet',
  OTHER = 'other',
  NURSERY = 'nursery',
  INVALID = 'invalid',
}

export enum HeatUpSpeedType {
  VerySlow = 'verySlow',
  Slow = 'slow',
  Moderate = 'moderate',
  Normal = 'normal',
  Fast = 'fast',
  VeryFast = 'veryFast',
}

export interface RoomActor {
  deviceId: string;
  heatingCircuit: number;
}

export enum AddActorConstraints {
  NO_CS_OR_CO2_FOR_CHANNEL = 'NO_CS_OR_CO2_FOR_CHANNEL',
  NO_HC_FOR_CHANNEL = 'NO_HC_FOR_CHANNEL',
}

export enum Co2LevelStatus {
  Good,
  AboveThreshold,
  CriticalThreshold,
}

export interface PvStringObject {
  pvStringIdLetter: string;
  electricityFeature: Feature<IsNumberValueProperty, never>;
  powerFeature: Feature<IsNumberValueProperty, never>;
  voltageFeature: Feature<IsNumberValueProperty, never>;
}

export interface ReplaceGatewayFormData {
  oldGatewaySerial: string;
  oldGatewayPassword: string;
  newGatewaySerial: string;
  newGatewayPassword: string;
}

export interface ReplaceGatewayFormGroup {
  oldGatewaySerial: FormControl<string>;
  oldGatewayPassword: FormControl<string>;
  newGatewaySerial: FormControl<string>;
  newGatewayPassword: FormControl<string>;
}
